import { quantitiesPayload } from '@/helpers/TicketTypeQuantities';
import { API } from '@/api/API';
import { dateTimeHorizon } from '@/api/dateTimeHorizon';
export async function fetchCalendarForTicketGroupIDs(event, ticketGroupIds) {
    const query = {
        _format: 'extended',
        'ticket_group_id._in': ticketGroupIds.join(','),
        'start_datetime._lt': dateTimeHorizon(event),
    };
    const response = await API.getCached(`events/${event.id}/calendar`, { query });
    return response.calendar._data;
}
export async function fetchCalendarForTicketTypes(event, quantities, includePricing) {
    const query = {
        _format: includePricing ? 'price' : 'extended',
        'start_datetime._lt': dateTimeHorizon(event),
    };
    const body = quantitiesPayload(quantities);
    const response = await API.post(`events/${event.id}/calendar`, { query, body });
    return response.calendar._data;
}
